import { combineReducers } from 'redux'
import { createAction, handleActions } from 'redux-actions'

import payment_addresses from './payment_addresses'

const getType = type => `@deposits/${type}`

export const setCode = createAction(getType('SET_CODE'))
export const toggleInvoiceDialog = createAction(getType('TOGGLE_INVOICE_DIALOG'))

const initialState = {
  code: '',
  invoice_dialog_opened: false
}

const reducer = handleActions(
  {
    [setCode]: (state, { payload }) => ({ ...state, code: payload }),
    [toggleInvoiceDialog]: (state, { payload }) => ({
      ...state,
      invoice_dialog_opened: !state.invoice_dialog_opened
    })
  },
  initialState
)

export default combineReducers({
  index: reducer,
  payment_addresses
})



// WEBPACK FOOTER //
// ./src/modules/deposits/index.js